function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "add-user-icon");

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("line", {
  x1: 19.06,
  y1: 2.64,
  x2: 19.06,
  y2: 9.51,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("line", {
  x1: 15.63,
  y1: 6.08,
  x2: 22.5,
  y2: 6.08,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("path", {
  d: "M11.57,14a7.65,7.65,0,0,1,2.14,5.18v.29H2.91v-.29A7.65,7.65,0,0,1,5.05,14a6.48,6.48,0,0,0,6.52,0m0-1.71a5.12,5.12,0,0,1-6.56,0c-2.1,1.16-3.52,4.33-3.52,6.89v1a.68.68,0,0,0,.68.68H14.43a.68.68,0,0,0,.68-.68v-1c0-2.56-1.42-5.73-3.52-6.89Z",
  fill: "currentColor"
}), React.createElement("path", {
  d: "M8.31,5.23A3.12,3.12,0,1,1,5.19,8.35,3.12,3.12,0,0,1,8.31,5.23m0-1.4a4.52,4.52,0,1,0,4.52,4.52A4.53,4.53,0,0,0,8.31,3.83Z",
  fill: "currentColor"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 22.83 22.83"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/add-user-icon.2d53bd2e.svg";
export { SvgComponent as ReactComponent };